const dam_animation_heightOfSectionBelowDamBg = 1230;
const dam_animation_heightOfDamBg = 260;
let dam_animation_viewPortHeight = 0;
const damDOMElementID = 'kk-dam-fill-animation';
const damDOMelement = document.querySelector(`#${damDOMElementID}`)

function damFillObserverAction(entries, observer) {
    let entry = entries[0];
    dam_animation_viewPortHeight = entry.rootBounds.height - 300;
    if (entry.isIntersecting) {
        let intersectingSectionBelowHeight = entry.intersectionRatio * dam_animation_heightOfSectionBelowDamBg;
        let remainingSpaceOnTopOfIntersectionSectionBelow = dam_animation_viewPortHeight - intersectingSectionBelowHeight;
        let damm_bg_fill_ratio = (remainingSpaceOnTopOfIntersectionSectionBelow / dam_animation_viewPortHeight) * 100;
        let dam_bg_fill_ratio = Math.round(damm_bg_fill_ratio);
        dam_bg_fill_ratio = Math.ceil(dam_bg_fill_ratio / 5) * 5;
        dam_bg_fill_ratio = dam_bg_fill_ratio + 10;

        if (dam_bg_fill_ratio > 5) {
            damDOMelement.style.setProperty('--damanivisibility', `visible`);
        } else {
            damDOMelement.style.setProperty('--damanivisibility', `hidden`);
        }
        damDOMelement.style.setProperty('--damaniheight', `${dam_bg_fill_ratio}%`);
    }
}

let damObserverOptions = {
    threshold: [0.0, 0.01, 0.1, 0.12, 0.13, 0.14, 0.15, 0.16, 0.17, 0.18, 0.19,
        0.2, 0.21, 0.22, 0.23, 0.24, 0.25, 0.26, 0.27, 0.28, 0.29,
        0.3, 0.31, 0.32, 0.33, 0.34, 0.35, 0.36, 0.37, 0.38, 0.39,
        0.4, 0.41, 0.42, 0.43, 0.44, 0.45, 0.46, 0.47, 0.48, 0.49,
        0.5, 0.51, 0.52, 0.53, 0.54, 0.55, 0.56, 0.57, 0.58, 0.59,
        0.6, 0.61, 0.62, 0.63, 0.64, 0.65, 0.66, 0.67, 0.68, 0.69,
        0.7, 0.71, 0.72, 0.73, 0.74, 0.75, 0.76, 0.77, 0.78, 0.79,
        0.8, 0.81, 0.82, 0.83, 0.84, 0.85, 0.86, 0.87, 0.88, 0.89,
        0.9, 0.91, 0.92, 0.93, 0.94, 0.95, 0.96, 0.97, 0.98, 0.99,
        1.0
    ]
}
let damObserver = new IntersectionObserver(damFillObserverAction, damObserverOptions);
let sectionBelowDamBgToBind = document.querySelector('#kk-section-below-dam-animation');
if(sectionBelowDamBgToBind) {
    damObserver.observe(sectionBelowDamBgToBind);
}